/* * @Author: Alex Gong * @Date: 2020-06-24 16:35:16 * @Last Modified by: rachel
* @Last Modified time: 2020-08-26 11:53:46 */
<template>
  <div class="ppr-header">
    <div class="header-left f_left" :title="currentVersion">
      <div class="f_left" :title="currentVersion">
        <img :src="getEnvInfo().logoUrl" alt="logo" class="tvuLogo" />
      </div>
      <div class="f_left slotBox">
        <div class="Text">
          <!-- <b>{{ getEnvInfo().title }}</b> -->
          {{ $t("lang.TVURecordingService") }}
        </div>
      </div>
    </div>
    <div class="header-right f_right">
      <div class="f_right userInfo">
      <!-- <span class="whats-new"><img src="@/assets/img/what's-new.svg"/></span> -->
        <el-dropdown trigger="click">
          <div class="f_left firstN" :style="{ backgroundColor: bgc }">
            {{ firstWord }}
          </div>
          <el-dropdown-menu slot="dropdown" class="userList">
            <el-dropdown-item class="nameDisplay">
              <div class="f_left firstN" :style="{ backgroundColor: bgc }">
                {{ firstWord }}
              </div>
              <div class="f_left nameSet">
                <div class="ellipsisOne" :title="getUserName">
                  {{ getUserName }}
                </div>
                <div class="ellipsisOne" :title="userInfo && userInfo.email">
                  {{ userInfo && userInfo.email }}
                </div>
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="langList">
              <div class="f_left">{{ $t("lang.language") }}</div>
              <div class="f_right">
                <span
                  class="translateEN pointer"
                  :class="{ greenActive: langEnActive }"
                  @click.stop="langChange('en')"
                  v-if="getEnvInfo().envIsTVU"
                  >EN</span
                >
                <span v-if="getEnvInfo().envIsTVU"> / </span>
                <span
                  class="translateZH pointer"
                  :class="{ greenActive: !langEnActive }"
                  @click.stop="langChange('zh')"
                  >中文</span
                >
              </div>
            </el-dropdown-item>
            <el-dropdown-item class="langList">
              <div class="f_left">{{ $t("lang.theme") }}</div>
              <div class="f_right">
                <span
                  class="translateEN pointer"
                  :class="{ greenActive: themeDarkActive }"
                  @click.stop="themeChange('dark')"
                  v-if="getEnvInfo().envIsTVU"
                  >{{ $t("lang.dark") }}</span
                >
                <span v-if="getEnvInfo().envIsTVU"> / </span>
                <span
                  class="translateZH pointer"
                  :class="{ greenActive: !themeDarkActive }"
                  @click.stop="themeChange('light')"
                  >{{ $t("lang.light") }}</span
                >
              </div>
            </el-dropdown-item>
            <el-dropdown-item>
              <span class="SignOut" @click.stop="logoutRecord">
                {{ $t("lang.logout") }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <tvu-service-jump-collect></tvu-service-jump-collect>
      <!-- <div :class="isActiveWaffle === true ? 'nav-icon-close' : 'nav-icon'" @click="drawerOpen"></div> -->
    </div>
  </div>
</template>
<script>
import { getUserInfo } from "@/Api/files";
import { logout, getBackendVersion } from "@/Api/common";
import Tool from "@/assets/js/common/utils.js";
import $store from "@/store/index.js";
import moment from "moment";
import Cookies from "js-cookie";
import { getEnvInitInfo } from "@/assets/js/envConfig";
const bgc = ["#4157C0", "#40B0B8", "#7046C2", "#C03939", "#B83B9B", "#D27D26"];
import { mapState } from 'vuex';
import { newloginservice } from '@/assets/js/config';

export default {
  name: "topMenu",
  data() {
    return {
      recordInput: "",
      bgc: "",
      lang: this.$i18n.locale,
      langEnActive: true,
      themeDarkActive: true,
      currentTheme: 'dark',
      currentVersion: "",
      isActiveWaffle: false
    };
  },
  created() {
    this.bgc = bgc[parseInt((Math.random() * 100) % 6)];

    getBackendVersion()
      .then((res) => {
        let version = window.localStorage.getItem("newRecordedVersion");
        let versionText =
          "FE version : " + version + "\n" + "BE Version : " + res;
        this.currentVersion = versionText;
      })
      .catch((err) => {
        this.currentVersion = window.localStorage.getItem("newRecordedVersion");
      });

    //console.log(version);
  },
  mounted() {
    const getTheme = Cookies.get('userTheme')
    document.body.classList.add(getTheme)
    console.log('getTheme', getTheme)
    if (getTheme === undefined) {
      this.themeChange('dark')
    } else {
      this.themeChange(getTheme)
    }
    if (String(getTheme) === 'null') {
      this.themeChange('dark')
    }
    // alert();
    const sessionValue = window.sessionStorage.getItem('register');
    if (sessionValue) {
      // window.sessionStorage.setItem('register', 1);
    } else {
      window.sessionStorage.setItem('register', 1);
      window.localStorage.setItem('recordRemoteStorageInfo', '');
    }
    const lang =
      Cookies.get("userLanguage") ||
      navigator.language ||
      navigator.userLanguage ||
      "en";
    if (window.location.href.includes("userLanguage")) {
      // 是否从pp跳转过来的
      // lang = window.location.href.split('lang')[1].split('=')[1].slice(0, 2)
      window.localStorage.removeItem("recordStorageInfo"); // 清空用户行为数据(PM要求 从pp跳转过来的直接回到record file目录)
      this.$store.state.downloadInfo = null;
      this.$router.push({ path: "/" });
      // window.location.href = window.location.origin;//直接回到record file目录
    }
    if (lang) {
      this.langChange(lang);
    }
    //this.getUserInfoF();
  },
  computed: {
  ...mapState({
      userInfo: (state) => state.userInfo,
      wafflemenuStatus: (state) => state.wafflemenuStatus,
    }),
    
    firstWord() {
      // 获取缩略名
      if (this.userInfo) {
        const userInfo = this.userInfo.firstName || this.userInfo.email;
        if (userInfo) {
          return userInfo.substring(0, 2);
        } else {
          return "";
        }
      }
      return "";
    },
    getUserName() {
      if (this.userInfo) {
        if (this.userInfo.userName == "") {
          return this.userInfo.firstName + this.userInfo.lastName;
        } else {
          return this.userInfo.userName;
        }
      } else {
        return "";
      }
    },
  },
  methods: {
    drawerOpen() {
      this.$store.dispatch("commitisWaffleMenu", true);
    },
    async getUserInfoF() {
      // 获取用户信息
      const res = await getUserInfo();
      if (res.data.errorCode == "0x0") {
        this.userInfo = res.data.result;
        this.$store.dispatch("commitUserInfo", res.data.result);
      }
    },
    getEnvInfo() {
      return getEnvInitInfo();
    },
    langChange(value) {
      if (String(value) === 'null') {
        value = 'en'
      }
      const domain = document.domain
        .split(".")
        .slice(-2)
        .join(".");
      Cookies.set("userLanguage", value, { domain, expires: 1000000000 });
      Cookies.set("userLanguage", value);
      this.$i18n.locale = value;
      if (value === "en") {
        this.langEnActive = true;
        moment.locale("en");
      } else {
        this.langEnActive = false;
        moment.locale("zh-CN");
      }
    },
    themeChange(valTheme) {
      if (String(valTheme) === 'null') {
        value = 'dark'
      }
      const domain = document.domain
        .split(".")
        .slice(-2)
        .join(".");
      // Cookies.set("userTheme", valTheme, { domain, expires: 1000000000 });
      Cookies.set('userTheme', valTheme);
      window.localStorage.setItem('userTheme', valTheme)
      // this.$i18n.locale = valTheme;
      // const applyTheme = document.getElementsByClassName("popperClass");
      if (valTheme === 'dark') {
        this.themeDarkActive = true;
        this.currentTheme = 'dark'
        this.$store.state.theme = 'dark'
        
        // applyTheme.className = this.currentTheme;
        document.body.classList.remove('light')
        document.body.classList.add(this.currentTheme)
        // this.$store.state.theme = null;
        moment.locale("dark");
      } else {
        this.themeDarkActive = false;
        this.currentTheme = 'light'
        this.$store.state.theme = 'light'
        document.body.classList.remove('dark')
        document.body.classList.add(this.currentTheme)
        // applyTheme.className = this.currentTheme;
        moment.locale("light");
      }
    },
    async logoutRecord() {
      const res = await logout();
      if (res.data.errorCode == "0x0") {
        const config = $store.config
          ? $store.config
          : JSON.parse(window.localStorage.getItem("newRcConfig"));
        window.localStorage.setItem("session", "");
        Tool.removeCookie();
        const protocol =
          document.location.protocol === "https:" ? "https://" : "http://"; // 获取协议
          // alert(`${protocol}${newloginservice}?url=${location.protocol}//${location.host}/&serviceName=Producer`)
        const redirectURL = `${protocol}${newloginservice}?url=${location.protocol}//${location.host}/&serviceName=Producer`;
        window.location.href = redirectURL;
        // window.location.href = `${protocol}${config.userServiceUrl}?url=${location.protocol}//${location.host}/&serviceName=Producer`;
      }
    },
  },
  watch: {
    wafflemenuStatus() {
      this.isActiveWaffle = this.wafflemenuStatus
    }
  },
};
</script>

<style lang="less" scoped>
.greenActive {
  color: #5dc045;
}

.userList .el-dropdown-menu__item:focus,
.userList .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: unset;
  color: unset;
}

.userList .nameDisplay {
  height: 96px;
  background: #eaeef2;

  .nameSet {
    color: #313436;
    margin-top: 18px;
    font-size: 18px;
    font-weight: 500;
    width: 72%;
    overflow: hidden;
  }
}

.userList {
  width: 320px;
  height: 200px;
  // height: 178px;
  background: #fff;
  -webkit-box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.04),
    0 4px 11px 0 rgba(0, 0, 0, 0.08), 0 2px 10px 0 rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.04), 0 4px 11px 0 rgba(0, 0, 0, 0.08),
    0 2px 10px 0 rgba(0, 0, 0, 0.06);

  .firstN {
    margin-top: 30px;
    color: #fff;
    width: 48px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: #447ac9;
    border-radius: 50%;
    cursor: pointer;
    margin-left: -3px;
    margin-right: 24px;
  }

  /deep/ .el-dropdown-menu__item {
    overflow: hidden;
    font-size: 18px;
  }
}

.ppr-header {
  height: 64px;
  background: rgba(255, 255, 255, 1);

  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.04), 0 4px 11px 0 rgba(0, 0, 0, 0.08),
    0 2px 10px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
  z-index: 10;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  .Text{
    font-size: 16px!important;
    font-weight: 700!important;
  }
  .header-left {
    height: 100%;
    line-height: 64px;
    height:64px;
    margin-left: 20px;
    display: flex;
    align-items: center;

    .tvuLogo {
      float: left;
      /*margin-top: 16px;*/
      width: 32px;
      height: 32px;
      margin-right: 16px;
    }
  }

  .header-right {
    line-height: 64px;
    height: 64px;
    margin-right: 20px;

    /deep/ .input {
      width: 400px;
      /*position: relative;*/

      .recordInput {
        width: 100%;
        background: rgba(246, 247, 250, 1);
        border: 1px solid rgba(220, 223, 228, 1);
      }

      .el-input__inner {
        padding-left: 32px;
      }

      .el-input__suffix {
        width: 32px;
        height: 32px;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .userInfo {
      padding-left: 24px;
      display:flex;
      align-items: center;
      // margin-right: 6px;
    }
  }

  .firstN {
    /*margin-top: 16px;*/
    color: #fff;
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #447ac9;
    border-radius: 50%;
    cursor: pointer;
  }
}
.nav-icon{
    background-image: url("../assets/img/items_nav_icon.png");
    // background: url("https://userservice.tvunetworks.com/serviceListUI/package.serviceList/images/items_nav_icon.png");
    width: 55px;
    height: 55px;
    cursor: pointer;
    margin-left: 16px;
    margin-top: 0;
}
.nav-icon-close{
    background-image: url("../assets/img/close_icon.png");
    // background: url("https://userservice.tvunetworks.com/serviceListUI/package.serviceList/images/close_icon.png");
    width: 55px;
    height: 55px;
    cursor: pointer;
    margin-left: 15px;
    margin-top: 0;
}
.whats-new{
    margin-right: 16px;
    // display: flex;
    display: none;
    align-items: center;
    justify-content: center;
}
.whats-new img{
    margin: 0;
    width: 24px;
    height: 24px;
    cursor: pointer;
}

/* ####### Dark Theme ####### */
.dark .ppr-header{
    background: #000000;
    .Text{
    color: #DBDBDB;
    font-size: 16px;
    font-weight: 700;
      }
}
// .dark .ppr-header{
//     background: #000000;
//     box-shadow: none;
//     .Text{
//          color:#fff;
//       }
// }
</style>
